import { UIHelper as uh } from '../../core';
import { StyleSheet } from 'react-native';
import React from 'react';
import MarkerListContainer from 'src/features/markers/MarkerListContainer';
import { Layout } from '@ui-kitten/components';

const styleContainer = StyleSheet.create({
  screenContainer: { flex: 1, paddingLeft: uh.w2DP(16), paddingRight: uh.w2DP(16), paddingBottom: uh.h2DP(20) }
});

const AllMarkersScreen = () => {
  //view
  return (
    <Layout level="2" style={styleContainer.screenContainer}>
      <MarkerListContainer />
    </Layout>
  );
};

export default AllMarkersScreen;
